/** This script was auto generated by 'TypeValidatorCreator' at 'src/infrastructure/scripts/Typescript/TypeValidator.ts' **/
import { createValidator } from '../../schema'
import type {
    MinimalCertificatesResponse,
    MinimalNonEmptyCertificatesResponse,
} from './Types'

const MinimalCertificatesResponseSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/MinimalCertificatesResponse',
    definitions: {
        MinimalCertificatesResponse: { type: 'array', items: { $ref: '#/definitions/CertificateResponse' }, deprecated: true },
        CertificateResponse: {
            type: 'object',
            properties: {
                id: { type: 'string' },
                issuedBy: {
                    type: 'object',
                    properties: {
                        commonName: { type: ['string', 'null'] },
                        organization: { type: 'string' },
                        organizationalUnit: { type: ['string', 'null'] },
                    },
                    required: ['commonName', 'organization', 'organizationalUnit'],
                },
                issuedTo: {
                    type: 'object',
                    properties: {
                        commonName: { type: ['string', 'null'] },
                        organization: { type: ['string', 'null'] },
                        organizationalUnit: { type: ['string', 'null'] },
                        alternativeNames: { type: 'array', items: { type: 'string' } },
                    },
                    required: ['commonName', 'organization', 'organizationalUnit', 'alternativeNames'],
                },
                keyUsage: { type: 'array', items: { type: 'string' } },
                extendedKeyUsage: { type: 'array', items: { type: 'string' } },
                basicConstraints: {
                    type: 'object',
                    properties: { isCA: { type: 'boolean' }, pathLength: { type: 'number' } },
                    required: ['isCA', 'pathLength'],
                },
                issuedOn: { type: 'number' },
                expiresOn: { type: 'number' },
                fingerprints: { $ref: '#/definitions/ReadonlyRecord%3C(%22sha1%22%7C%22sha256%22)%2Cstring%3E' },
                removable: { type: 'boolean' },
            },
            required: ['id', 'issuedBy', 'issuedTo', 'keyUsage', 'extendedKeyUsage', 'basicConstraints', 'issuedOn', 'expiresOn', 'fingerprints', 'removable'],
            deprecated: true,
        },
        'ReadonlyRecord<("sha1"|"sha256"),string>': {
            type: 'object',
            properties: { sha1: { type: 'string' }, sha256: { type: 'string' } },
            required: ['sha1', 'sha256'],
        },
    },
}
export const isMinimalCertificatesResponse = createValidator<MinimalCertificatesResponse>(MinimalCertificatesResponseSchema, 'isMinimalCertificatesResponse')
const MinimalNonEmptyCertificatesResponseSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/MinimalNonEmptyCertificatesResponse',
    definitions: {
        MinimalNonEmptyCertificatesResponse: { $ref: '#/definitions/ReadonlyNonEmptyArray%3CCertificateResponse%3E', deprecated: true },
        'ReadonlyNonEmptyArray<CertificateResponse>': {
            anyOf: [
                {
                    allOf: [
                        { type: 'array', items: { $ref: '#/definitions/CertificateResponse' }, minItems: 1 },
                        { type: 'array', items: { $ref: '#/definitions/CertificateResponse' } },
                    ],
                },
                {
                    allOf: [
                        { type: 'array', items: { $ref: '#/definitions/CertificateResponse' }, minItems: 1 },
                        { type: 'array', items: { $ref: '#/definitions/CertificateResponse' } },
                    ],
                },
            ],
        },
        CertificateResponse: {
            type: 'object',
            properties: {
                id: { type: 'string' },
                issuedBy: {
                    type: 'object',
                    properties: {
                        commonName: { type: ['string', 'null'] },
                        organization: { type: 'string' },
                        organizationalUnit: { type: ['string', 'null'] },
                    },
                    required: ['commonName', 'organization', 'organizationalUnit'],
                },
                issuedTo: {
                    type: 'object',
                    properties: {
                        commonName: { type: ['string', 'null'] },
                        organization: { type: ['string', 'null'] },
                        organizationalUnit: { type: ['string', 'null'] },
                        alternativeNames: { type: 'array', items: { type: 'string' } },
                    },
                    required: ['commonName', 'organization', 'organizationalUnit', 'alternativeNames'],
                },
                keyUsage: { type: 'array', items: { type: 'string' } },
                extendedKeyUsage: { type: 'array', items: { type: 'string' } },
                basicConstraints: {
                    type: 'object',
                    properties: { isCA: { type: 'boolean' }, pathLength: { type: 'number' } },
                    required: ['isCA', 'pathLength'],
                },
                issuedOn: { type: 'number' },
                expiresOn: { type: 'number' },
                fingerprints: { $ref: '#/definitions/ReadonlyRecord%3C(%22sha1%22%7C%22sha256%22)%2Cstring%3E' },
                removable: { type: 'boolean' },
            },
            required: ['id', 'issuedBy', 'issuedTo', 'keyUsage', 'extendedKeyUsage', 'basicConstraints', 'issuedOn', 'expiresOn', 'fingerprints', 'removable'],
            deprecated: true,
        },
        'ReadonlyRecord<("sha1"|"sha256"),string>': {
            type: 'object',
            properties: { sha1: { type: 'string' }, sha256: { type: 'string' } },
            required: ['sha1', 'sha256'],
        },
    },
}
export const isMinimalNonEmptyCertificatesResponse = createValidator<MinimalNonEmptyCertificatesResponse>(
    MinimalNonEmptyCertificatesResponseSchema,
    'isMinimalNonEmptyCertificatesResponse'
)
